import { createContext } from 'react';

export type FabMenuOrigin = 'bottom' | 'rail';

export type FabMenuContextValue = {
  open: boolean;
  /**
   * Quelle nav a ouvert le menu (barre mobile ou rail desktop). Détermine si
   * la section "Accéder à" (destinations secondaires) doit s'afficher : sur
   * desktop, ces destinations sont déjà visibles dans le rail, donc inutile
   * de les répéter (LOT 1.1).
   */
  origin: FabMenuOrigin | null;
  setOpen: (open: boolean) => void;
  toggle: (origin: FabMenuOrigin) => void;
};

export const FabMenuContext = createContext<FabMenuContextValue | null>(null);
